import React from 'react'
import { alpha } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import TablaVistaLotes from './TablaVistaLotes';

export default function Filtros(props) {
    const { rows } = props

    const [filterb, Setfilter] = React.useState(false)

    const fixedOptionsdep = [];
    const [valuedep, setValueDep] = React.useState([]);

    const fixedOptionsper = [];
    const [valueper, setValuePer] = React.useState([]);

    let lotesfiltrados = []

    function test(filtros, val, rows) {
        filtros.forEach((filtro) => {
            const lotes = rows.filter((lt) => lt[val] === filtro[val])
            lotes.forEach(lote => {
                lotesfiltrados.push(lote)
            });
        })
        return lotesfiltrados;
    }

    const [datosnuevos2, SetDatosN2] = React.useState([])
    const [datosnuevos3, SetDatosN3] = React.useState([])


    const datadepta = [...new Map(rows.map((m) => [m.descdepto
        , m])).values()]

    const selecperiodo = valuedep.length === 0 ? [...new Map(rows.map((m) => [m.numeroperiodo
        , m])).values()] : [...new Map(datosnuevos2.map((m) => [m.numeroperiodo
            , m])).values()]


    React.useEffect(() => {
        const obtenerInfo = () => {

            const fil3 = test(valuedep, 'descdepto', rows)
            SetDatosN2(fil3)
        }
        obtenerInfo()
    }, [rows])

    React.useEffect(() => {
        const obtenerInfo = () => {

            const fil2 = test(valueper, 'numeroperiodo', datosnuevos2)
            SetDatosN3(fil2)
        }
        obtenerInfo()
    }, [datosnuevos2])

    const datageneral = valuedep.length === 0 ? rows : valueper.length === 0 ? datosnuevos2 : datosnuevos3;

    return (<>
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(filterb === true && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            <Tooltip title="Filter list">
                <IconButton onClick={e => Setfilter(!filterb)}>
                    <FilterListIcon />
                </IconButton>
            </Tooltip>

            {filterb === true ? <Grid container spacing={2} alignItems="center">

                <Grid item md={4}>
                    <Autocomplete
                        size="small"
                        multiple
                        id="fixed-tags-demo"
                        value={valuedep}
                        onChange={(event, newValue) => {

                            setValueDep([
                                ...fixedOptionsdep,
                                ...newValue.filter((option) => fixedOptionsdep.indexOf(option) === -1),
                            ]);
                            const selec = ([
                                ...fixedOptionsdep,
                                ...newValue.filter((option) => fixedOptionsdep.indexOf(option) === -1),
                            ]);

                            const fil2 = test(selec, 'descdepto', rows)
                            SetDatosN2(fil2)
                        }}
                        options={datadepta}
                        getOptionLabel={(option) => option.descdepto}
                        renderTags={(tagValue, getTagProps) =>
                            tagValue.map((option, index) => (
                                <Chip
                                    label={option.descdepto}
                                    {...getTagProps({ index })}
                                    disabled={fixedOptionsdep.indexOf(option) !== -1}
                                />
                            ))
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Departamento" placeholder="Departamento" />
                        )}
                    />
                </Grid>
                {valuedep.length === 0 ? null :
                    <Grid item md={4}>
                        <Autocomplete
                            size="small"
                            multiple
                            id="fixed-tags-demo"
                            value={valueper}
                            onChange={(event, newValue) => {

                                setValuePer([
                                    ...fixedOptionsdep,
                                    ...newValue.filter((option) => fixedOptionsdep.indexOf(option) === -1),
                                ]);
                                const selec = ([
                                    ...fixedOptionsdep,
                                    ...newValue.filter((option) => fixedOptionsdep.indexOf(option) === -1),
                                ]);

                                const fil2 = test(selec, 'numeroperiodo', datosnuevos2)
                                SetDatosN3(fil2)
                            }}
                            options={selecperiodo}
                            getOptionLabel={(option) => option.numeroperiodo}
                            renderTags={(tagValue, getTagProps) =>
                                tagValue.map((option, index) => (
                                    <Chip
                                        label={option.numeroperiodo}
                                        {...getTagProps({ index })}
                                        disabled={fixedOptionsper.indexOf(option) !== -1}
                                    />
                                ))
                            }

                            renderInput={(params) => (
                                <TextField {...params} label="Periodo" placeholder="Periodo" />
                            )}
                        />

                    </Grid>}
            </Grid> : null}

        </Toolbar>
        <TablaVistaLotes
            rows={datageneral}
        />
    </>
    );
}
